import * as XLSX from 'xlsx';
import { INotfis } from '../interfaces/response/Notfis/INotfisResponse';

// Função para converter e baixar o arquivo XLSX
export function converterEbaixarXLSX(
  objeto: INotfis[],
  nomeArquivo: string
): void {
  // Converte o objeto para uma matriz de objetos simples
  const dadosParaExportar = objeto.map((item) => {
    let novoObjeto: { [key: string]: any } = {};
    novoObjeto.idIntegracaoNotfis = item.idIntegracaoNotfis;
    novoObjeto.idServico = item.idServico;
    novoObjeto.numeroNF = item.numeroNF;
    novoObjeto.serieNF = item.serieNF;
    novoObjeto.chaveAcesso = item.chaveAcesso;
    novoObjeto.dataEmissaoNota = item.dataEmissaoNota;
    novoObjeto.pesoTotal = item.pesoTotal;
    novoObjeto.pesoBruto = item.pesoBruto;
    novoObjeto.totalNota = item.totalNota;
    novoObjeto.qtdVolumes = item.qtdVolumes;
    novoObjeto.identificacaoCliente = item.identificacaoCliente;
    novoObjeto.descricaoProduto = item.descricaoProduto;
    novoObjeto.codigoCarga = item.codigoCarga;
    novoObjeto.tipoEntrega = item.tipoEntrega;
    novoObjeto.tipoDocumento = item.tipoDocumento;
    novoObjeto.idTipoDocumento = item.idTipoDocumento;
    novoObjeto.origem = item.origem;
    novoObjeto.dataPrevisaoEntrega = item.dataPrevisaoEntrega;
    novoObjeto.cubagemTotal = item.cubagemTotal;
    novoObjeto.valorICMS = item.valorICMS;
    novoObjeto.bandeiraDoPedido = item.bandeiraDoPedido;
    novoObjeto.Cubagem_EAN = item.cubagem?.ean || '';
    novoObjeto.Cubagem_Altura = item.cubagem ? item.cubagem.altura / 100 : '';
    novoObjeto.Cubagem_Largura = item.cubagem ? item.cubagem.largura / 100 : '';
    novoObjeto.Cubagem_Profundidade = item.cubagem
      ? item.cubagem.profundidade / 100
      : '';
    novoObjeto.agendamento_dataAgendamento = item.agendamento.dataAgendamento;
    novoObjeto.agendamento_periodo = item.agendamento.periodo;
    novoObjeto.consumidor_cnpj = item.consumidor.cnpj;
    novoObjeto.consumidor_cpf = item.consumidor.cpf;
    novoObjeto.consumidor_nome = item.consumidor.nome;
    novoObjeto.consumidor_logradouro = item.consumidor.logradouro;
    novoObjeto.consumidor_numero = item.consumidor.numero;
    novoObjeto.consumidor_bairro = item.consumidor.bairro;
    novoObjeto.consumidor_cidade = item.consumidor.cidade;
    novoObjeto.consumidor_cep = item.consumidor.cep;
    novoObjeto.consumidor_uf = item.consumidor.uf;
    novoObjeto.consumidor_complemento = item.consumidor.complemento;
    novoObjeto.consumidor_codMun = item.consumidor.codMun;
    novoObjeto.consumidor_telefone = item.consumidor.telefone;
    novoObjeto.consumidor_inscricaoEstadual = item.consumidor.inscricaoEstadual;
    novoObjeto.consumidor_razaoSocial = item.consumidor.razaoSocial;
    novoObjeto.consumidor_email = item.consumidor.email;
    novoObjeto.consumidor_pontoReferencia = item.consumidor.pontoReferencia;
    novoObjeto.emitente_cnpj = item.emitente.cnpj;
    novoObjeto.emitente_cpf = item.emitente.cpf;
    novoObjeto.emitente_nome = item.emitente.nome;
    novoObjeto.emitente_logradouro = item.emitente.logradouro;
    novoObjeto.emitente_numero = item.emitente.numero;
    novoObjeto.emitente_bairro = item.emitente.bairro;
    novoObjeto.emitente_cidade = item.emitente.cidade;
    novoObjeto.emitente_cep = item.emitente.cep;
    novoObjeto.emitente_uf = item.emitente.uf;
    novoObjeto.emitente_complemento = item.emitente.complemento;
    novoObjeto.emitente_codMun = item.emitente.codMun;
    novoObjeto.emitente_telefone = item.emitente.telefone;
    novoObjeto.emitente_inscricaoEstadual = item.emitente.inscricaoEstadual;
    novoObjeto.emitente_razaoSocial = item.emitente.razaoSocial;
    novoObjeto.emitente_email = item.emitente.email;
    novoObjeto.emitente_pontoReferencia = item.emitente.pontoReferencia;
    novoObjeto.tomadorServico_cnpj = item.tomadorServico.cnpj;
    novoObjeto.tomadorServico_cpf = item.tomadorServico.cpf;
    novoObjeto.tomadorServico_nome = item.tomadorServico.nome;
    novoObjeto.tomadorServico_logradouro = item.tomadorServico.logradouro;
    novoObjeto.tomadorServico_numero = item.tomadorServico.numero;
    novoObjeto.tomadorServico_bairro = item.tomadorServico.bairro;
    novoObjeto.tomadorServico_cidade = item.tomadorServico.cidade;
    novoObjeto.tomadorServico_cep = item.tomadorServico.cep;
    novoObjeto.tomadorServico_uf = item.tomadorServico.uf;
    novoObjeto.tomadorServico_complemento = item.tomadorServico.complemento;
    novoObjeto.tomadorServico_codMun = item.tomadorServico.codMun;
    novoObjeto.tomadorServico_telefone = item.tomadorServico.telefone;
    novoObjeto.tomadorServico_inscricaoEstadual =
      item.tomadorServico.inscricaoEstadual;
    novoObjeto.tomadorServico_razaoSocial = item.tomadorServico.razaoSocial;
    novoObjeto.tomadorServico_email = item.tomadorServico.email;
    novoObjeto.tomadorServico_pontoReferencia =
      item.tomadorServico.pontoReferencia;
    novoObjeto.expedidorServico_cnpj = item.expedidorServico.cnpj;
    novoObjeto.expedidorServico_cpf = item.expedidorServico.cpf;
    novoObjeto.expedidorServico_nome = item.expedidorServico.nome;
    novoObjeto.expedidorServico_logradouro = item.expedidorServico.logradouro;
    novoObjeto.expedidorServico_numero = item.expedidorServico.numero;
    novoObjeto.expedidorServico_bairro = item.expedidorServico.bairro;
    novoObjeto.expedidorServico_cidade = item.expedidorServico.cidade;
    novoObjeto.expedidorServico_cep = item.expedidorServico.cep;
    novoObjeto.expedidorServico_uf = item.expedidorServico.uf;
    novoObjeto.expedidorServico_complemento = item.expedidorServico.complemento;
    novoObjeto.expedidorServico_codMun = item.expedidorServico.codMun;
    novoObjeto.expedidorServico_telefone = item.expedidorServico.telefone;
    novoObjeto.expedidorServico_inscricaoEstadual =
      item.expedidorServico.inscricaoEstadual;
    novoObjeto.expedidorServico_razaoSocial = item.expedidorServico.razaoSocial;
    novoObjeto.expedidorServico_email = item.expedidorServico.email;
    novoObjeto.expedidorServico_pontoReferencia =
      item.expedidorServico.pontoReferencia;

    item.itens.forEach((subitem, index) => {
      const objetoFinalItem: { [key: string]: any } = {
        ...novoObjeto,
        [`item_${index + 1}_id`]: subitem.id,
        [`item_${index + 1}_etiqueta`]: subitem.etiqueta,
        [`item_${index + 1}_codigoBarras`]: subitem.codigoBarras,
        [`item_${index + 1}_descricao`]: subitem.descricao,
        [`item_${index + 1}_peso`]: subitem.peso,
        [`item_${index + 1}_altura`]: subitem.altura,
        [`item_${index + 1}_largura`]: subitem.largura,
        [`item_${index + 1}_profundidade`]: subitem.profundidade,
        [`item_${index + 1}_cubagem`]: subitem.cubagem,
        [`item_${index + 1}_codigo`]: subitem.codigo,
        [`item_${index + 1}_tipo`]: subitem.tipo,
        [`item_${index + 1}_qtde`]: subitem.qtde,
      };
      novoObjeto = objetoFinalItem;
    });

    item.volumes.forEach((subitem, index) => {
      const objetoFinalItem: { [key: string]: any } = {
        ...novoObjeto,
        [`volume_${index + 1}_id`]: subitem.id,
        [`volume_${index + 1}_etiqueta`]: subitem.etiqueta,
        [`volume_${index + 1}_codigoBarras`]: subitem.codigoBarras,
        [`volume_${index + 1}_peso`]: subitem.peso,
        [`volume_${index + 1}_cubagem`]: subitem.cubagem,
        [`volume_${index + 1}_altura`]: subitem.altura,
        [`volume_${index + 1}_largura`]: subitem.largura,
        [`volume_${index + 1}_profundidade`]: subitem.profundidade,
      };
      novoObjeto = objetoFinalItem;
    });

    return novoObjeto;
  });

  // Cria uma planilha
  const ws = XLSX.utils.json_to_sheet(dadosParaExportar);

  // Cria um livro
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Planilha 1');

  // Converte o livro para uma string binária
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

  // Converte a string binária para um blob
  const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });

  // Cria um link para o blob
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = nomeArquivo;

  // Adiciona o link ao DOM e simula o clique para iniciar o download
  document.body.appendChild(link);
  link.click();

  // Remove o link do DOM
  document.body.removeChild(link);
}

// Função auxiliar para converter uma string binária em um array buffer
function s2ab(s: string): ArrayBuffer {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < s.length; i++) {
    // eslint-disable-next-line no-bitwise
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
}
